import { FC } from 'react';
import { Board, Council, Society } from 'types';
import PageListHeader from '../Headers/PageListHeader';
import GoBackButton from '../Buttons/GoBackButton';

type BoardDetailsHeaderProps = {
  board: Board | Council | undefined;
  society: Society | undefined;
};

const BoardDetailsHeader: FC<BoardDetailsHeaderProps> = ({
  board,
  society,
}) => (
  <PageListHeader
    subTitle={board?.name || ''}
    subTitleSuffix={society?.name || ''}
    actions={[<GoBackButton />]}
  />
);

export default BoardDetailsHeader;
